import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import PaymentOption from '../../summary/VariantSummary/payment/paymentOption';
import UserDetailPopUp from '../../../components/Elements/userDetailPopUp/userDetailPopUp';
import CourseDetail from '../../coursDetail/courseDetail';
import ApiService from '../../../services/ApiService';
import { useDispatch, useSelector } from 'react-redux';
import { setCurseHadings } from '../../../reducers/reposReducers';
import { API_URL, API_URL_getCourseWWWInfoPortal} from '../../../config';
import ComplateData from "../../summary/VariantSummary/complateData.js"
import CustomButtons from '../../../components/Elements/Buttons/customButton';

const PriceVariant = (props) => {
    const camp = JSON.parse( localStorage.getItem("campHeadingFull"))
    const history = useHistory();
    const apiService = ApiService.getInstance();
    const date = new Date();
    const key = localStorage.getItem('keyURL');
    let userID = localStorage.getItem('participantUsersID');
    //coursesHeadingsID
    
    const [isFullData, setIsFullData] = useState(true)
    
   let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    if (month < 10) {
        month = '0' + month;
    }
    if (day < 10) {
        day = '0' + day;
    }


let start = year+"-"+month+"-"+day
    // {
    //     "usersID": 18442,
    //     "login": null,
    //     "firstName": "Damian",
    //     "lastName": "Gąska",
    //     "genderDVID": 1,
    //     "dateOfBirdth": "01/01/0001 00:00:00",
    //     "pesel": "53062075174",
    //     "street": "wolska",
    //     "building": "21",
    //     "flat": "",
    //     "city": "kazimierz",
    //     "postalCode": "32-112",
    //     "email": "pinyin@getmail.fun",
    //     "phone": "634653423",
    //     "personalDataProcessingConsent": true,
    //     "active": "1",
    //     "currentPurchaseKey": null,
    //     "consentReceiveSmsEmailPhone": false,
    //     "marketingAgreement": false,
    //     "memberCardNumber": ""
    // }
    // if(isFullData){
        
    //     if(userDataCheck.city.length == 0||userDataCheck.building.length == 0||userDataCheck.firstName.length == 0||userDataCheck.lastName.length == 0||userDataCheck.pesel.length == 0||userDataCheck.postalCode.length == 0||userDataCheck.street.length == 0||userDataCheck.dateOfBirdth === "01/01/0001 00:00:00"){
    //     setIsFullData(false)}
        
    // }
    // if(isFullData&&parcipientNameDataCheck!= null){
        
    //     if(parcipientNameDataCheck.city.length == 0||parcipientNameDataCheck.building.length == 0||parcipientNameDataCheck.firstName.length == 0||parcipientNameDataCheck.lastName.length == 0||parcipientNameDataCheck.pesel.length == 0||parcipientNameDataCheck.postalCode.length == 0||parcipientNameDataCheck.street.length == 0||parcipientNameDataCheck.dateOfBirdth === "01/01/0001 00:00:00"){
    //     setIsFullData(false)}
        
    // }

    const parcipientName = localStorage.getItem('userName');
    const startDate = `${year}-${month}-${day}`;
    const dispatch = useDispatch();
    const usersParticipant = useSelector((state) => state.repos.usersParticipant);
    const users = useSelector((state) => state.repos.users);
    let coursesHeadings;
    const [entryFee, setEntryLocalFee] = useState('0');
    const [openMonth, setOpenMonth] = useState(false);
    const [res, setRes] = useState([]);
    const [formData] = useState({
        courseHeadingName: key, // 'Żwiry-K1', // TODO będzie przychodić w linku w gecie
        productsLevel2:3,
        current_LocalizationsID: '0',
    });
    const [CheckUserEntryFeeParams, setCheckUserEntryFeeParams] = useState({
        usersID: userID, // 'Żwiry-K1', // TODO będzie przychodić w linku w gecie
        localizationsID: coursesHeadings,
        current_LocalizationsID: '0',
    });
    let responseCoursesHeadingsID;
    if(userID == undefined|| userID == ""){
        userID = localStorage.getItem('usersID');
    }

    // const methodCheckUserEntryFee = async () => {
    //     const CheckUserEntryFeeParamsSend = {
    //         usersID: userID,
    //         localizationsID: coursesHeadings,
    //         current_LocalizationsID: '0',
    //     };
    //     await apiService
    //         .asyncApiPost('CheckUserEntryFee', CheckUserEntryFeeParamsSend)
    //         .then((response) => {
    //          if(response.responseBody.body != undefined){
    //             props.setFee(
    //                 response.responseBody.body
    //                     ? response.responseBody.body.price.toString()
    //                     : "0"
    //             );
    //             setEntryLocalFee(
    //                 response.responseBody.body
    //                     ? response.responseBody.body.price.toString()
    //                     : "0"
    //             );}
    //         });

    //     return 'Finished methodCheckUserEntryFee';
    // };

    const methodGetCourseWWWInfo = async () => {
        let urlApi = `${API_URL_getCourseWWWInfoPortal}getCourseWWWInfoPortal`
       
        fetch(
            `${urlApi}`,
            {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: null,
                },
                body: JSON.stringify(formData),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((response) => {
      
                dispatch(setCurseHadings(response.body));
                localStorage.setItem('coursesHeadings', JSON.stringify(response.body));
                setCheckUserEntryFeeParams({
                    ...CheckUserEntryFeeParams,
                    localizationsID: response.body.localizationsID,
                });
          
                coursesHeadings = response.body.localizationsID;
                localStorage.setItem('localizationsID', response.body.localizationsID);
                localStorage.setItem('coursesHeadingsID', response.body.coursesHeadingsID);
                localStorage.setItem('startingDate', response.body.startingDate);
                localStorage.setItem('endData', response.body.closingDate);
                responseCoursesHeadingsID = response.body.coursesHeadingsID;
                methodGetPriceByCourseHeadingsID();
                // methodCheckUserEntryFee();
            });

        return 'Finished methodGetCourseWWWInfo';
    };

    const methodGetPriceByCourseHeadingsID = async () => {
   
        await apiService
            .asyncApiPost('GetPriceByCourseHeadingsID', {
                coursesHeadingsID: key,
                current_LocalizationsID: '0',
                startDate: `${start}`,
            })
            .then((response) => {
                if (response.body.length != 0) {
                    
                    let dataSort = response.body.sort(function (a, b) {
                        if (a.paymentTypesDVID > b.paymentTypesDVID) {
                            return 1;
                        }
                        if (a.paymentTypesDVID < b.paymentTypesDVID) {
                            return -1;
                        }
                        return 0;
                    });

                    response.body.map((e) => {
                        if (e.periodsOfValidityDVID === 3) {
                            setOpenMonth(true);
                        }
                    });
                    props.setDataPay(response.body)
                    // let sortRespons = response.body
                    setRes(dataSort);
                } else {
                }
            });

        return 'Finished methodGetPriceByCourseHeadingsID';
    };
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event' : 'checkout',
            'step' : `Wartian cenowy`
        });
      
        methodGetCourseWWWInfo();
 
          
    }, []);
    return (
        <>
            
                <div className="variantSummary">
                <div className="vairaintSummary_tittle">
                <div className="vairaintSummary_tittleWrapper">
                        <CustomTittle>Wybierz wariant cenowy</CustomTittle>

                        <div className="variantSummary_option">
                           
                       
                            <div className="tittle_stage">
                                
                            </div>
                            <div className="paymentOptions">
                      
                                {props.dataPay.map((payment,index) =>
                                    payment.periodsOfValidityDVID == 0 ? (
                                        payment.specialDiet ? (
                                            <PaymentOption
                                            key={"keyVariant" + index}
                                            isCamp={true}
                                            isRaty={true}
                                            labelCamp="Pierwsza rata jest zadatkiem i jest gwaracją rezerwacji miejsca"
                                                duration={'zł / semestr'}
                                                next={()=>{props.next(payment)}}
                                                title="RATY Z DIETĄ INNĄ"
                                               
                                                payment={payment}
                                                price={payment.currentPrice}
                                                oneMounth={payment.unitAmount}
                                            ></PaymentOption>
                                        ) : (
                                            <PaymentOption
                                            key={"keyVariant" + index}
                                            isCamp={true}
                                                isRaty={true}
                                                next={()=>{props.next(payment)}}
                                                labelCamp="Pierwsza rata jest zadatkiem i jest gwaracją rezerwacji miejsca"
                                                title="PŁATNOŚĆ RATALNA"
                                                
                                                payment={payment}
                                                price={payment.currentPrice}
                                                oneMounth={payment.unitAmount}
                                            ></PaymentOption>
                                        )
                                    ) : (
                                        ''
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                    {/* <CustomButtons clickFunction={props.next}  classButton="solid" size="big">DALEJ</CustomButtons> */}
                </div>

                <div className="dataSummary_detailsDetails">
                    <div className="columDetials_wrapper">
                        <CustomTittle>Szczegóły zamówienia</CustomTittle>
                        <CourseDetail
                            wrapNavigator={props.wrapNavigator}
                            setWrapNavigator={props.setWrapNavigator}
                            setHeader={(e) => {
                                props.setHeader(e);
                            }}
                            header={props.header}
                        ></CourseDetail>
                        {/* <UserDetailPopUp
           
                                onclick={()=>{props.setNavigator(1,"chooseUser")}} 
                        
                            title="Uczestnik:"
                            label={parcipientName}
                            icon={
                                <svg
                                    width="17"
                                    height="18"
                                    viewBox="0 0 17 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z"
                                        fill="#CC0033"
                                    />
                                </svg>
                            }
                        ></UserDetailPopUp> */}
                        {/* <UserDetailPopUp
                            onclick={() => {
                                props.setNavigator(2, 'data');
                            }}
                            title="Data rozpoczęcia:"
                            label={
                                props.start.split('-')[2] +
                                '-' +
                                props.start.split('-')[1] +
                                '-' +
                                props.start.split('-')[0]
                            }
                            icon={
                                <svg
                                    width="17"
                                    height="18"
                                    viewBox="0 0 17 18"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z"
                                        fill="#CC0033"
                                    />
                                </svg>
                            }
                        ></UserDetailPopUp> */}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PriceVariant;
